import { Link } from 'react-router-dom';
import { Linkedin, Instagram, ArrowRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#1A1A1A]" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="block mb-4">
              <span className="text-[22px] text-white" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}>She Built This</span>
            </Link>
            <p className="text-sm leading-relaxed text-white/50 mb-6" style={{ fontFamily: "'Lora', serif" }}>
              A research platform documenting women who built something real.
            </p>
            <div className="flex gap-3">
              <a href="https://www.linkedin.com/company/shebuiltthis" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/20 flex items-center justify-center text-white/50 hover:text-[#C25E3E] hover:border-[#C25E3E] transition-colors" aria-label="LinkedIn">
                <Linkedin size={16} />
              </a>
              <a href="https://instagram.com/shebuiltthis" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/20 flex items-center justify-center text-white/50 hover:text-[#C25E3E] hover:border-[#C25E3E] transition-colors" aria-label="Instagram">
                <Instagram size={16} />
              </a>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h4 className="text-[11px] tracking-[0.2em] uppercase text-[#C25E3E] mb-5" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}>Platform</h4>
            {['Stories', 'The Film', 'Soundtrack', 'Podcast', 'Blog'].map((label) => (
              <Link key={label} to={`/${label === 'Stories' ? 'profiles' : label === 'The Film' ? 'film' : label.toLowerCase()}`} className="block py-1.5 text-sm text-white/50 hover:text-white transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>
                {label}
              </Link>
            ))}
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-[11px] tracking-[0.2em] uppercase text-[#C25E3E] mb-5" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}>Resources</h4>
            {[
              { label: 'The Book', to: '/book' },
              { label: 'Edition 2', to: '/book/edition-2' },
              { label: 'Courses', to: '/youth' },
              { label: 'Participate', to: '/participate' },
              { label: 'Nominate', to: '/nominate' },
            ].map((link) => (
              <Link key={link.to} to={link.to} className="block py-1.5 text-sm text-white/50 hover:text-white transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>
                {link.label}
              </Link>
            ))}
          </div>

          {/* Book promo */}
          <div>
            <h4 className="text-[11px] tracking-[0.2em] uppercase text-[#C25E3E] mb-5" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}>The Book</h4>
            <p className="text-sm text-white/50 mb-4" style={{ fontFamily: "'Lora', serif" }}>
              Available on Amazon Kindle. Edition 2 coming April 2026.
            </p>
            <a href="https://a.co/d/0jdiF8K1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center h-10 px-6 bg-[#C25E3E] text-white text-[11px] tracking-[0.15em] uppercase hover:bg-white hover:text-[#1A1A1A] transition-all" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}>
              Buy Now <ArrowRight size={12} className="ml-2" />
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[11px] text-white/30" style={{ fontFamily: "'Outfit', sans-serif" }}>
            &copy; {currentYear} She Built This. All rights reserved.
          </p>
          <p className="text-[11px] text-white/30" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Founded by Dr. Neha Dewan
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
